<div class="header-menu-user-dropdown">
  <button
    [class]="'header-menu-user-dropdown__button ' + className"
    type="button"
    id="topMenuUserCollapse"
    role="button"
    [ngClass]="{ 'header-menu-user-dropdown__button--opened': !collapsed }"
    [attr.aria-expanded]="!collapsed"
    aria-controls="top-bar-user-dropdown"
    (click)="toggleCollapsed()"
    (focusout)="setCollapsed(true)"
  >
    {{ username }}
    @if (withArrow) {
      <app-svg-icon
        class="header-menu-user-dropdown__chevron-down-icon"
        icon="chevron-down-icon"
        fill="white"
        [width]="14"
        [height]="14"
      ></app-svg-icon>
    }
  </button>
  <ul
    class="header-menu-user-dropdown__dropdown-menu dropdown-menu"
    id="top-bar-user-dropdown"
    aria-labelledby="topMenuUserCollapseDropdown"
    [collapse]="collapsed"
    [isAnimated]="false"
  >
    <li role="menuitem">
      <div (mousedown)="goTo(yourAccountLink)">{{ yourAccountNameLabel }}</div>
    </li>
    <li role="menuitem">
      <div (mousedown)="logOut()">{{ logoutLabel }}</div>
    </li>
  </ul>
</div>
